import { useEffect } from 'react';
import Header from './components/Layout/Header';
import { AnalyticsProvider } from './contexts/AnalyticsContext';
import { ThemeProvider } from './contexts/ThemeContext';
import Analytics from './pages/Analytics';

declare const __APP_VERSION__: string;

function App() {
  useEffect(() => {
    console.log(
      `%c Monday Dashboard v${__APP_VERSION__} `,
      'background: #B68AFF; color: #fff; padding: 2px 8px; border-radius: 4px;'
    );
  }, []);

  return (
    <ThemeProvider>
      <AnalyticsProvider>
        <div className="min-h-screen bg-solid-bg text-base transition-colors scrollbar-overlay">
          <Header />
          <main>
            <Analytics />
          </main>
        </div>
      </AnalyticsProvider>
    </ThemeProvider>
  );
}

export default App;
